<style type="text/css">
    * {
        box-sizing: border-box
    }

    body {
        font-family: "Lato", sans-serif;
    }

    /* Style the tab */

    .tab {
        float: left;
        border: 1px solid #ccc;
        background-color: #f1f1f1;
        width: 30%;
        height: 400px;
        overflow-y: auto;
    }

    /* Style the buttons inside the tab */

    .tab button {
        display: block;
        background-color: inherit;
        color: black;
        padding: 22px 16px;
        width: 100%;
        border: none;
        outline: none;
        text-align: left;
        cursor: pointer;
        transition: 0.3s;
        font-size: 17px;
    }


    /* Change background color of buttons on hover */

    .tab button:hover {
        background-color: #ddd;
    }

    /* Create an active/current "tab button" class */

    .tab button.active {
        background-color: #ccc;
    }

    /* Style the tab content */

    .tabcontent {
        float: left;
        padding: 0px 20px;
        width: 100%;
        border-left: none;
        /* height: 400px; */
        height: auto;
        overflow: auto;
    }

    .tabcontentinner {

        max-width: 100%;
    }

    .tabcontentinner2 {

        max-width: 630px;
    }

    h3 {
        text-align: center;
        /* background-color: #2ea1f8;
    color: #ffffff; */
    }

    .block label {
        display: block;
    }

    .number-input {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f2f4f7));
        background: linear-gradient(180deg, #fff, #f2f4f7);
        border: 1px solid #dfe3e9;
        border-radius: 4px;
        height: 39px;
        width: 250px;
        padding-left: 15px;
        color: #7f8fa4;
        position: relative;
        cursor: pointer;
    }

    .c-choice1 {
        margin: 33px 0 0.9375rem 0;
        color: #354052;
        font-size: 0;
        font-weight: 400;
        margin-top: 0px;
        margin-bottom: 0px;
    }



    .Vspan1 {
        position: relative;
        top: 0px;
        right: 0;
        color: #1a1a1a;
        font-size: 14px;
        left: -200px;
        z-index: 10000;
        width: 10px;
    }

    .c-choice__label {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 14px;
        font-weight: normal !important;
        color: #1a1a1a;
    }

    .border {
        border: 1px solid #1a1a1a;
        color: #1a1a1a;
        font-weight: 500;
    }

    .center {
        margin-left: auto;
        margin-right: auto;
    }

    .rightimg {
        background-image: url('/assets/common/images/32px_new.png');
        background-position: 1px -68px;
        width: 26px;
        height: 25px;
        border: none;
        background-color: inherit;
    }

    .canceltimg {
        background-image: url('/assets/common/images/32px_new.png');
        background-position: -32px -68px;
        width: 26px;
        height: 25px;
    }

    .uploadimg {
        background-image: url('/assets/common/images/32px_new.png');
        background-position: -260px -6px;
        width: 25px;
        height: 22px
    }

    .btnSave {
        height: 40px;
        padding-left: 1px;
        padding-bottom: 30px;
        padding-top: 8px;
        height: 42px;
        width: 113px;
    }

    .clsHidden {
        /* visibility: hidden; */
        display: none;
    }

    .clsVisible {
        visibility: visible;
    }

    .filedisplay {
        display: inline-block;
        width: 197px;
    }

    .filelable {
        font-family: 'Source Sans Pro', sans-serif;
        font-size: 14px;
        font-weight: normal !important;
        flex-basis: 100%;
        margin: 0 0 0.3125rem 0;
        color: #7f8fa4;
    }

    .logopreview {
        font-family: 'Source Sans Pro', sans-serif;
        font-weight: normal !important;
        flex-basis: 100%;
        margin: 0 0 0.3125rem 0;
        color: #7f8fa4;
    }

    .margin-left16 {
        margin-left: 16px;
    }

    .drpWidth300 {
        width: 300px;
    }

    .drpWidth250 {
        width: 250px;
    }

    .nopadding {
        padding: 0 !important;
        margin: 0 !important;
    }


    .footerbutton {
        margin: 10px 0 10px 30px;
        float: left;
    }

    .margin26 {
        margin-top: 26px
    }

    .creport {
        /* border: 1px solid; */
        /* min-height: 220px;
        max-height: 220px; */
        /* overflow: auto; */
    }

    .marginTop10 {
        margin-top: 10px;
    }

    .fileupload {
        display: none;
    }

    .logo {
        height: auto !important;
        width: 300px;
        margin: 0 auto;
    }

    .logoArea {
        position: relative;
        width: 300px;
        margin: 0 auto;
        margin-top: 30px;
    }

    @media (max-width:1024px) {

        .logoArea {
            width: auto;
        }

        .logo {
            width: auto;

        }

    }

    .logoArea .removeImg {
        position: absolute;
        right: 0;
        bottom: 100%;
    }

    .clsDiplayInlineBlock {
        display: inline-block;
    }

    .marginleft15 {
        margin-left: 15px;
    }

    .width100p {
        width: 100%;
    }


    .ufilename {
        margin-right: 5px;
        padding: 5px;
    }

    .fupdiv {
        margin-top: 5px;
        margin-left: 1px;
    }

    .c-choice__input+.c-choice__label.custom-label:before {
        line-height: 20px;
    }

    .fileUploadModule {
        text-align: center;
        padding: 30px;
        border: 2px dashed #ddd;
        border-radius: 15px;
    }

    .gdiv .svg-container,
    .gdiv .main-svg {
        max-width: 100%;
        max-height: 100%;
    }

    .modebar {
        display: none !important;
    }

    .c-choice--radio {
        margin-right: 15px;
    }
</style>
<div class="theme-custom">
<div id="settingPage" [@routerTransition]>
    <div class="m-subheader">
        <div class="d-flex align-items-center">
            <div class="mr-auto">
                <h3 class="m-subheader__title">
                    <span>Settings</span>
                </h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        <ul class="nav nav-tabs  m-tabs-line m-tabs-line--primary marginleft15" role="tablist">


            <li class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks active" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" id="defaultOpen" (click)="tabChange($event, 'tab3')">Company logo</a>
            </li>
            <!-- <li class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab" aria-selected="true"
                   (click)="tabChange($event, 'tab3')">Company Logo</a>
            </li> -->
            <li class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab2')">Custom report fields</a>
            </li>
            <li class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab4')">Default voltages</a>
            </li>

            <li class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab1')">Cable sizing</a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab5')">Data transfer</a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab6')">Copy Utility</a>
            </li>
            <li *ngIf="roleId == 1 || roleId == 2" class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab8')">Project Transfer Utility</a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab9')">App Settings</a>
            </li>
            <li *ngIf="false && isAdminUser && settingOutput?.webFacingSeo && settingOutput?.webFacingSeo.length > 0" class="nav-item m-tabs__item">
                <a class="nav-link m-tabs__link tablinks" data-toggle="tab" href="javascript:void(0)" role="tab"
                    aria-selected="true" (click)="tabChange($event, 'tab10')">Web Facing</a>
            </li>
        </ul>
    </div>

    <div id="tab1" class="tabcontent" style="display: none;">
        <div class="tabcontentinner">

            <div class="mb-5">
                <!-- <div class="card-header">
                </div> -->
                <div class="card-body">
                    <div class="">
                        <h5 class="mb-3">Preferred Standards</h5>
                        <!-- <hr> -->

                        <div class="c-field u-mb-small" style="width:340px">
                            <select id="drpPreferredStandard" class="c-select" style="width:340px">
                                <option *ngFor="let item of cableSizeStandards; let ind = index"
                                    [selected]="ind == settingInput.standards_CableSizing" value="{{ind}}">
                                    {{item}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div>
                        <h5 class="mb-3">Short-circuit</h5>
                        <!-- <hr> -->

                        <div class="c-field u-mb-small drpWidth300">
                            <label class="c-field__label c-choice__label">Voltage factor, c</label>
                            <div>
                                <input type="number" style="width:100px;padding-right: 15px" class="number-input"
                                    min="0.1" max="10" (change)="CommonValidationFn(4, $event,3)"
                                    [(ngModel)]="settingInput.short_Circuit_VoltageFactor_C" step=".1">
                            </div>
                        </div>
                    </div>


                </div>
            </div>


        </div>
    </div>

    <div id="tab2" class="tabcontent" style="display: none;">
        <div class="tabcontentinner2">



            <div class="mb-5">
                <!-- <div class="card-header">
                    <h5 class="mb-0">Custom Report Fields</h5>
                </div> -->
                <div class="">
                    <div class="card-body">
                        <h5 class="mb-3">Custom Report Fields</h5>

                        <div *ngIf="planLevel <= 1">
                            <div class="c-field u-mb-small">
                                <label (click)="setPlansUrl()" class="c-field__label pl-2"
                                    style="color:#2C77E8;padding-left:2px;text-decoration:underline;cursor: hand;cursor: pointer;">Upgrade
                                    Now to Show custom fields in Reports</label>
                            </div>
                        </div>
                        <div *ngIf="planLevel > 1" style="text-align:left;padding-bottom:2px;">
                            <div class="c-choice1 c-choice--checkbox u-float-left wizard-checkbox pl-2">
                                <input type="checkbox" checked class="c-choice__input" type="checkbox"
                                    name="checkboxes1" id="use-custom"
                                    [(ngModel)]="settingInput.customeReportFields_ShowCustomField">
                                <label for="use-custom" class="c-choice__label custom-label">Show custom fields in
                                    Reports</label>
                            </div>
                            <br />
                            <!-- <div class="margin26">
                            <h5 class="mb-3">Custom Fields for Reports</h5>
                        </div> -->
                            <div class="creport">
                                <table class="table" id="reports">
                                    <thead>
                                        <tr>
                                            <th class="c-choice__label">Field Name</th>
                                            <th class="c-choice__label">Value</th>
                                        </tr>
                                    </thead>
                                            <tbody>
                                        <!-- style="width:250px;" style="width:250px;" [ngStyle]="{'backgroundColor': i == settingInput.customFields.length ? '#007bff' : '' }" -->
                                        <tr *ngFor="let field of settingInput.customFields; let i = index"
                                            (click)=setDeleteIndex(i)
                                            [ngStyle]="{'backgroundColor': field.isSelected == true ? '#007bff' : '' }">
                                            <td>
                                                <input style="width:100%;max-width: 250px;"
                                                    [(ngModel)]="field.fieldNameKey" type="text" class="number-input"
                                                    [ngClass]="{'is-invalid': customFieldErrors[i]?.name}"
                                                    name="fieldName_{{i}}"
                                                    (ngModelChange)="clearCustomFieldErrors(i)"
                                                    placeholder="&#60; Click once to Edit &#62;" />
                                                <div *ngIf="customFieldErrors[i]?.name" class="text-danger small mt-1">
                                                    Field Name is required.
                                                </div>
                                            </td>
                                            <td>
                                                <input style="width:100%;max-width: 250px;" [(ngModel)]="field.values"
                                                    type="text" class="number-input"
                                                    [ngClass]="{'is-invalid': customFieldErrors[i]?.value}"
                                                    name="fieldValue_{{i}}"
                                                    (ngModelChange)="clearCustomFieldErrors(i)"
                                                    placeholder="&#60; Click once to Edit &#62;" />
                                                <div *ngIf="customFieldErrors[i]?.value" class="text-danger small mt-1">
                                                    Field Value is required.
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div *ngIf="customReportFieldValidationMessage" class="text-danger mb-2">
                                    {{customReportFieldValidationMessage}}
                                </div>
                            </div>
                            <div class="text-center border-top pt-3 mt-4">
                                <button class="btn btn-secondary border" (click)="addReportsFields()">Add</button>
                                <button class="btn btn-secondary border"
                                    (click)="deleteReportsFields(indextoDelete)">Delete</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>



        </div>

    </div>

    <div id="tab3" class="tabcontent" style="display: block;">
        <div class="tabcontentinner2">





            <div class="mb-5">
                <!-- <div class="card-header">
                </div> -->
                <div class="card-body">
                    <h5 class="mb-3">Company Logo</h5>

                    <!-- <div *ngIf="planName === 'Base'" class="nopadding">
                        <div class="c-field u-mb-small">
                            <label (click)="SetUpgradeLink()" class="c-field__label"
                                style="color:#2C77E8;padding-left:2px;text-decoration:underline;cursor: hand;cursor: pointer;">Upgrade
                                Now to Show Logo in Reports</label>
                        </div>
                    </div> -->
                    <div>
                        <div class="c-choice1 c-choice--checkbox u-float-left wizard-checkbox width100p pl-2">
                            <input type="checkbox" class="c-choice__input" id="check"
                                [(ngModel)]="settingInput.companyLogo_ShowLogo">
                            <label class="c-choice__label custom-label" for="check"
                                usetiful_id="settings__showLogoInReports-checkbox--primary">Show Logo in Reports</label>
                        </div>
                        <br>
                        <br>
                        <div [class]="settingInput.companyLogo_ShowLogo ? 'clsVisible':'clsHidden'">
                            <h5 class="logopreview" class="clsDiplayInlineBlock-">Logo preview</h5>
                            <div class="fileUploadModule">
                                <div class="logoArea">
                                    <div class="removeImg">
                                        <img *ngIf='deleteVisible' class="canceltimg btnRemove" alt="remove"
                                            title="Remove Image" src="assets/common/images/Transparent.gif" height=""
                                            (click)="removeLogo()">
                                    </div>
                                    <div class="logo">
                                        <img alt=" Company logo" [src]="settingInput.company_Logo_LogoPresignedUrl"
                                            name="logoimage" class="img-responsive"
                                            style="max-width:100%;height:auto !important">
                                    </div>
                                </div>

                                <div>
                                    <br />
                                    <div class="marginTop10">

                                        <input id="fileupload" type="file"
                                            class="filedisplay c-choice__label fileupload" accept="image/*"
                                            placeholder="Upload file" (change)='SetLogoImage($event)' />
                                        <button type="button" (click)="openfileControl()"
                                            class="btn btn-secondary border" [disabled]=btnuploadDisabled>
                                            <img class="uploadimg" src="assets/common/images/Transparent.gif"> Click to
                                            Upload Company Logo
                                        </button>
                                        <br />
                                        <label style="color: red" *ngIf="isInvalidFileType"> *Only Image Files are
                                            Allowed.</label>
                                        <div *ngIf="settingInput.companyLogo_FileName fupdiv" class="marginTop10">
                                            <label class="c-field__label clsDiplayInlineBlock">File name</label>
                                            <label class="c-field__label clsDiplayInlineBlock ufilename">
                                                &nbsp;&nbsp;
                                                {{settingInput.companyLogo_FileName}}
                                            </label>
                                        </div>
                                        <label class="c-field__label marginTop10"> Click Accept after upload to save
                                            logo. </label>
                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- <div id="tab3" class="tabcontent">
        <div *ngIf="planName === 'Base'" class="col-md-4 nopadding">
            <div class="c-field u-mb-small">
                <label (click)="SetUpgradeLink()" class="c-field__label" style="color:#2C77E8;padding-left:2px;text-decoration:underline;cursor: hand;cursor: pointer;">Upgrade Now to Show logo in Reports</label>
            </div>
        </div>
        <div *ngIf="planName !== 'Base'">
            <div class="c-choice1 c-choice--checkbox u-float-left wizard-checkbox width100p">
                <input type="checkbox" class="c-choice__input" id="check" [(ngModel)]="settingInput.companyLogo_ShowLogo">
                <label class="c-choice__label" for="check">Show logo in Reports</label>
            </div>
            <br>
            <br>
            <div [class]="settingInput.companyLogo_ShowLogo ? 'clsVisible':'clsHidden'">
                <h5 class="logopreview" class="clsDiplayInlineBlock">Logo preview</h5>
                <img *ngIf='deleteVisible' class="canceltimg btnRemove" alt="remove" title="Remove Image" src="/assets/common/images/Transparent.gif"
                     height="" (click)="removeLogo()">

                <div class="marginTop10">
                    <div class="logo">
                        <img alt=" Company logo" [src]="settingInput.company_Logo_LogoPresignedUrl" name="logoimage" class="img-responsive" style="width:100%;height:auto !important">
                    </div>
                </div>

                <div>
                    <br />
                    <div class="marginTop10">

                        <input id="fileupload" type="file" class="filedisplay c-choice__label fileupload" accept="image/*" placeholder="Upload file"
                               (change)='SetLogoImage($event)' />
                        <button type="button" (click)="openfileControl()" class="btn btn-secondary border" [disabled]=btnuploadDisabled>
                            <img class="uploadimg" src="/assets/common/images/Transparent.gif"> Click to upload company logo
                        </button>
                        <br />
                        <label style="color: red" *ngIf="isInvalidFileType"> *Only Image Files are Allowed.</label>
                        <div *ngIf="settingInput.companyLogo_FileName fupdiv">
                            <label class="c-field__label clsDiplayInlineBlock">File name</label>
                            <label class="c-field__label clsDiplayInlineBlock ufilename">
                                &nbsp;&nbsp;
                                {{settingInput.companyLogo_FileName}}
                            </label>
                        </div>
                        <label class="c-field__label marginTop10"> Click Accept after upload to save logo. </label>
                    </div>



                </div>

            </div>
        </div>
    </div>  -->


    <div id="tab4" class="tabcontent" style="display: none;">
        <div class="tabcontentinner">

            <div class="mb-5">
                <!-- <div class="card-header">
                </div> -->
                <div class="card-body">
                    <div class="mb-5">


                        <h5 class="mb-3">Voltages</h5>
                        <!-- <hr> -->

                        <div class="c-field u-mb-small">
                            <label class="c-field__label c-choice__label">3 phase AC Voltage (V)</label>
                            <input style="width:100px;padding-right: 15px" class="number-input" type="number"
                                name="val1" [(ngModel)]="settingInput.deafaultVoltages_ThreePhaseAcvoltage" min="1"
                                max="1000" (change)="CommonValidationFn(3, $event,2)">
                            <!-- <span class="Vspan1">V </span> -->
                            <!--<label class="filelable">Also used for Max Demand calculations</label>-->
                        </div>
                        <div class="c-field u-mb-small">
                            <label class="c-field__label c-choice__label">1 phase AC Voltage (V)</label>
                            <input style="width:100px;padding-right: 15px" type="number" class="number-input"
                                [(ngModel)]="settingInput.deafaultVoltages_OnePhaseAVoltage" min="1" max="1000"
                                (change)="CommonValidationFn(1, $event,2)">
                            <!-- <span class="Vspan1">V</span> -->
                        </div>

                        <div class="c-field u-mb-small">
                            <label class="c-field__label c-choice__label">DC Voltage (V)</label>
                            <input style="width:100px;padding-right: 15px" type="number" class="number-input"
                                [(ngModel)]="settingInput.deafaultVoltages_DcVoltage" min="1" max="1500"
                                (change)="CommonValidationFn(0, $event,2)">
                            <!-- <span class="Vspan1">V</span> -->
                        </div>

                    </div>

                    <!-- <div>
                    <h5 class="mb-3">Short-circuit</h5>
                   
                    <div class="c-field u-mb-small drpWidth300">
                        <label class="c-field__label">Voltage factor, c</label>
                        <div>
                            <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,3)" [(ngModel)]="settingInput.short_Circuit_VoltageFactor_C" step=".1">
                        </div>
                        </div>
                </div> -->


                </div>
            </div>
            <!-- <div class="card mb-5">
                <div class="card-header">
                    <h5 class="mb-0">Voltages</h5>
                </div>
                <div class="card-body">
                   
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">3 phase AC Voltage (V)</label>
                        <input class="number-input" type="number" name="val1" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_ThreePhaseAcvoltage" min="1" max="1000" (change)="CommonValidationFn(3, $event)" >
                      
                    </div>
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">1 phase AC Voltage (V)</label>
                        <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_OnePhaseAVoltage" min="1" max="1000" (change)="CommonValidationFn(1, $event)" >
                    </div>
            
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">DC Voltage (V)</label>
                        <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_DcVoltage" min="1" max="1500" (change)="CommonValidationFn(0, $event)" >
                    </div>
                   
                </div>
            </div> -->


        </div>
    </div>

    <div id="tab5" class="tabcontent" style="display: none;">
        <div class="tabcontentinner" *ngIf="isAdminUser">
            <div class="mb-5">
                <div class="card-body">

                    <div class="mb-5">
                        <div class="row">
                            <div class="col-6">

                                <input id="fileuploadexcel" type="file" class="filedisplay c-choice__label fileupload"
                                    accept=".xlsx" placeholder="Upload file"
                                    (change)='SetExcelFileUpload($event,"add")' />
                                <input id="fileuploadexcel2" type="file" class="filedisplay c-choice__label fileupload"
                                    accept=".xlsx" placeholder="Upload file"
                                    (change)='SetExcelFileUpload($event,"modify")' />
                                <button type="button" (click)="openexcelfileControl()" class="btn btn-secondary border"
                                    [disabled]=btnuploadDisabled>
                                    <img class="uploadimg" src="assets/common/images/Transparent.gif"> Add New
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-8" style="overflow: auto;
                        height: 500px;">
                                <div class="table-scrollable table-scrollable-borderless">
                                    <table class="table table-hover table-light">
                                        <thead>
                                            <tr class="uppercase">
                                                <th>
                                                    File Details
                                                </th>
                                                <th>
                                                    Uploaded time
                                                </th>

                                                <th>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let m of filesOutput; let index = index">

                                            <td>
                                                {{m.name}}
                                            </td>
                                            <td>
                                                {{m.fileDate}}
                                            </td>
                                            <td>
                                                <!-- <input id="fileuploadexcel" type="file" class="filedisplay c-choice__label fileupload" accept=".xlsx" placeholder="Upload file"
                                                    (change)='SetExcelFileUpload($event)' /> -->
                                                <button type="button" (click)="openexcelfileControlUpdate()"
                                                    class="btn btn-secondary border" [disabled]=btnuploadDisabled>
                                                    <img class="uploadimg" src="assets/common/images/Transparent.gif">
                                                    Replace
                                                </button>

                                                <button (click)="DeleteExcelFile(m.manname,m.fileType)"
                                                    style="height:46.09px" type="button"
                                                    class="btn btn-secondary border" [disabled]=btnuploadDisabled>
                                                    Delete
                                                </button>
                                            </td>

                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <!-- <div class="col-4">
                                    <div class="col-4">
                                            <button (click)="DeleteExcelFile()" type="button" class="btn btn-secondary border" [disabled]=btnuploadDisabled>
                                                     Delete (Data of the Selected Manufacturer will be deleted)
                                                </button>
                                           
                                    </div>
                            </div> -->
                        </div>

                        <!-- <angular-loader></angular-loader> -->


                    </div>

                    <!-- <div>
                    <h5 class="mb-3">Short-circuit</h5>
                   
                    <div class="c-field u-mb-small drpWidth300">
                        <label class="c-field__label">Voltage factor, c</label>
                        <div>
                            <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,3)" [(ngModel)]="settingInput.short_Circuit_VoltageFactor_C" step=".1">
                        </div>
                        </div>
                </div> -->


                </div>
            </div>
            <!-- <div class="card mb-5">
                <div class="card-header">
                    <h5 class="mb-0">Voltages</h5>
                </div>
                <div class="card-body">
                   
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">3 phase AC Voltage (V)</label>
                        <input class="number-input" type="number" name="val1" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_ThreePhaseAcvoltage" min="1" max="1000" (change)="CommonValidationFn(3, $event)" >
                      
                    </div>
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">1 phase AC Voltage (V)</label>
                        <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_OnePhaseAVoltage" min="1" max="1000" (change)="CommonValidationFn(1, $event)" >
                    </div>
            
                    <div class="c-field u-mb-small">
                        <label class="c-field__label">DC Voltage (V)</label>
                        <input type="number" class="number-input" (keyup)="Allowdecimalwithplaces($event,2)" [(ngModel)]="settingInput.deafaultVoltages_DcVoltage" min="1" max="1500" (change)="CommonValidationFn(0, $event)" >
                    </div>
                   
                </div>
            </div> -->
            <!-- <div id="chartContainer" style="height: 300px; width: 100%;"> -->

            <!-- </div> -->



        </div>

    </div>

    <div id="tab6" class="tabcontent" style="display: none;">
        <div class="tabcontentinner" *ngIf="isAdminUser">
            <div class="mb-5 col-lg-6 col-md-8 col-sm-12 col-xs-12 mx-auto">
                <div class="card-body">
                    <h4 class="mb-3 text-center">Copy calculations</h4>
                    <form id="frmUtility" #copyCalculationForm="ngForm"
                        (ngSubmit)="onCopyCalculation(copyCalculationForm)">
                        <div class="order-md-1">
                            <h5 class="mt-3">Source on Prodcution server</h5>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label for="firstName">Calculation URL</label>

                                    <input type="text" class="form-control" [(ngModel)]="copyUtilityObj.CalculationUrl"
                                        id="CalculationUrl" #calculationUrl="ngModel" name="CalculationUrl" required="">

                                    <span class="text-danger"
                                        *ngIf="(frmSubmit && copyCalculationForm.submitted) && calculationUrl.errors?.required">
                                        Calculation URL is required.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="order-md-1">
                            <h5 class="mt-3">Destination on Development server</h5>
                            <div class="row">
                                <div class="col-md-6 col-xs-12 mb-3">
                                    <label for="firstName">Username of account</label>
                                    <input type="text" class="form-control" [(ngModel)]="copyUtilityObj.UserName"
                                        #username="ngModel" name="username" required="">
                                    <span class="text-danger"
                                        *ngIf="(frmSubmit && copyCalculationForm.submitted) && username.errors?.required">
                                        Username is required.
                                    </span>
                                </div>
                                <div class="col-md-6 col-xs-12 mb-3">
                                    <label for="firstName">Project name (new or existing)</label>
                                    <input type="text" class="form-control" [(ngModel)]="copyUtilityObj.ProjectName"
                                        #project="ngModel" name="project" required="">
                                    <span class="text-danger"
                                        *ngIf="(frmSubmit && copyCalculationForm.submitted) && project.errors?.required">
                                        Project is required.
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="order-md-1">
                            <button type="submit" class="btn btn-success float-right" style="min-width: 165px;"
                                [disabled]="copyCalcLoader">
                                <span *ngIf="!copyCalcLoader">Copy Calculation</span>
                                <i *ngIf="copyCalcLoader" class="fa fa-spinner fa-spin"></i></button>
                            <button type="button" class="btn btn-primary float-right mr-3" (click)="downloadXml()"
                                data-toggle="tooltip" data-placement="auto"
                                title="Download Input XML, Only source calculation URL is required."
                                style="min-width: 165px;" [disabled]="downloadInputXmlLoader">
                                <span *ngIf="!downloadInputXmlLoader">Download Input XML</span>
                                <i *ngIf="downloadInputXmlLoader" class="fa fa-spinner fa-spin"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


    <div id="tab7" class="tabcontent" style="display: none;">
        <div class="tabcontentinner" *ngIf="isAdminUser">




            <div class="mb-5">

                <div class="card-body">
                    <div class="mb-5">
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label class="c-field__label" for="ddlPhases">Manufacturer</label>
                                    <div class="custom-selectbox">

                                        <button type="button" class="btn btn-secondary"
                                            (click)="showProtectiveDeviceUI()">Protective Device</button>
                                        <button type="button" class="btn btn-secondary"
                                            (click)="showCurveDataUI()">Curve
                                            Data</button>

                                    </div>
                                </div>
                            </div>



                        </div>




                        <div class="row">


                            <div class="col-4">
                                <div class="form-horizontal">
                                    <div class="form-group">
                                        <label for="project-name" class="c-field__label">Xml</label>
                                        <textarea class="form-control" id="txtxml" [(ngModel)]="xmlData"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="row" >
                    <div class="col-3">
                        <div class="table-scrollable table-scrollable-borderless">
                            <table class="table table-hover table-light">
                                <thead>
                                    <tr class="uppercase">
                                        <th >
                                            poles
                                        </th>
                                        <th>
                                            PN
                                        </th>
                                        
                                        
                                    </tr>
                                </thead>
                                <tr *ngFor="let m of polesTableOutput; let index = index">
                                    
                                    <td>
                                        {{m.poles}}
                                    </td>
                                    <td>
                                        {{m.pn}}
                                    </td>
                                   
                                </tr>
                            </table>
                        </div>
                    </div>
            <div class="col-5">
                <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light">
                        <thead>
                            <tr class="uppercase">
                                <th >
                                    poles
                                </th>
                                <th>
                                    ue_min_v
                                </th>
                                <th>
                                    ue_max_v
                                </th>
                                <th>
                                    Icu_kA
                                </th>
                                
                            </tr>
                        </thead>
                        <tr *ngFor="let m of breakingOutput; let index = index">
                            
                            <td>
                                {{m.poles}}
                            </td>
                            <td>
                                {{m.uminv}}
                            </td>
                            <td>
                                {{m.umaxv}}
                            </td>
                            <td>
                                <span>{{m.icuka}}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="col-4">
                <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light">
                        <thead>
                            <tr class="uppercase">
                                <th >
                                    Umin_V
                                </th>
                                <th>
                                    Umax_V
                                </th>
                                
                                
                            </tr>
                        </thead>
                        <tr *ngFor="let m of operationalTableOutput; let index = index">
                            
                            <td>
                                {{m.uminV}}
                            </td>
                            <td>
                                {{m.umaxV}}
                            </td>
                           
                        </tr>
                    </table>
                </div>
            </div>


            </div> -->

                    </div>
                </div>


            </div>
        </div>
    </div>

    <div id="tab8" class="tabcontent" style="display: none;">
        <div class="tabcontentinner" *ngIf="roleId == 1 || roleId == 2" style="height: calc(100vh - 260px);">
            <div class="mb-5 col-lg-6 col-md-8 col-sm-12 col-xs-12 mx-auto">
                <div class="card-body">
                    <h4 class="mb-3 text-center">Project transfer utility</h4>
                    <form id="frmSample" #sampleCalculationForm="ngForm"
                        (ngSubmit)="onProjectCopy(sampleCalculationForm)">
                        <div class="order-md-1">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label class="d-block" for="firstName">Transfer the Project to</label>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="c-choice--radio">
                                                <input type="radio" name="TargetUsers" id="AllUsers"
                                                    [(ngModel)]="sampleCalcObj.TargetUserType" class="c-choice__input"
                                                    [value]="1" #TargetUsers="ngModel" required="">
                                                <label class="c-choice__label" for="AllUsers">All Users</label>
                                            </div>
                                            <div class="c-choice--radio">
                                                <input type="radio" name="TargetUsers" id="PaidUsers"
                                                    [(ngModel)]="sampleCalcObj.TargetUserType" class="c-choice__input"
                                                    [value]="2" #TargetUsers="ngModel" required="">
                                                <label class="c-choice__label" for="PaidUsers">Paid Users</label>
                                            </div>
                                            <div class="c-choice--radio">
                                                <input type="radio" name="TargetUsers" id="FreeTrialUsers"
                                                    [(ngModel)]="sampleCalcObj.TargetUserType" class="c-choice__input"
                                                    [value]="3" #TargetUsers="ngModel" required="">
                                                <label class="c-choice__label" for="FreeTrialUsers">Free Trial
                                                    Users</label>
                                            </div>
                                            <div class="c-choice--radio">
                                                <input type="radio" name="TargetUsers" id="SpecificUser"
                                                    [(ngModel)]="sampleCalcObj.TargetUserType" class="c-choice__input"
                                                    [value]="4" #TargetUsers="ngModel" required="">
                                                <label class="c-choice__label" for="SpecificUser">Specified
                                                    Usernames</label>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="d-block text-danger"
                                        *ngIf="(frmSubmitSampleCalc && sampleCalculationForm.submitted) && TargetUsers.errors?.required">
                                        This field is required.
                                    </span>
                                </div>
                                <div class="col-md-12 mb-3" *ngIf="sampleCalcObj.TargetUserType == 4">
                                    <label>Specify Usernames(separate using commas)</label>
                                    <input type="text" class="form-control" [(ngModel)]="sampleCalcObj.UserNames"
                                        placeholder="Please enter usernames comma separated" #usernames="ngModel"
                                        name="UserNames" required="">
                                    <span class="text-danger"
                                        *ngIf="(frmSubmitSampleCalc && sampleCalculationForm.submitted) && usernames.errors?.required">
                                        Usernames required.
                                    </span>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label>Project Name</label>
                                    <ng-select [clearable]="false" [items]="projectOutput" bindLabel="name"
                                        placeholder="Select Project" [searchable]="true" bindValue="id"
                                        [(ngModel)]="sampleCalcObj.ProjectId" #project="ngModel" name="project"
                                        required>
                                    </ng-select>
                                    <span class="text-danger"
                                        *ngIf="(frmSubmitSampleCalc && sampleCalculationForm.submitted) && project.errors?.required">
                                        Project is required.
                                    </span>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="d-block" for="firstName">If Project Name exists in the user
                                        account</label>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="c-choice--radio">
                                                <input type="radio" name="ProjectExists" id="ReplaceExistingProject"
                                                    [(ngModel)]="sampleCalcObj.ProjectType" class="c-choice__input"
                                                    [value]="1" #ProjectExists="ngModel" required="">
                                                <label class="c-choice__label" for="ReplaceExistingProject">Replace
                                                    entire project</label>
                                            </div>
                                            <div class="c-choice--radio">
                                                <input type="radio" name="ProjectExists" id="AddCalculations"
                                                    [(ngModel)]="sampleCalcObj.ProjectType" class="c-choice__input"
                                                    [value]="2" #ProjectExists="ngModel" required="">
                                                <label class="c-choice__label" for="AddCalculations">Add to and replace
                                                    calculations in existing project</label>
                                            </div>
                                            <div class="c-choice--radio">
                                                <input type="radio" name="ProjectExists" id="SkipUsers"
                                                    [(ngModel)]="sampleCalcObj.ProjectType" class="c-choice__input"
                                                    [value]="3" #ProjectExists="ngModel" required="">
                                                <label class="c-choice__label" for="SkipUsers">Skip user if project
                                                    exists</label>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="d-block text-danger"
                                        *ngIf="(frmSubmitSampleCalc && sampleCalculationForm.submitted) && ProjectExists.errors?.required">
                                        This field is required.
                                    </span>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <p style="color: orange;font-size: 14px;">Transfer will be only applicable to
                                        <b>{{cableSizeValue}}</b> users.
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div class="order-md-1">
                            <button type="submit" class="btn btn-success float-right" [disabled]="SampleCalcLoader">
                                <i *ngIf="SampleCalcLoader" class="fa fa-spinner fa-spin"></i>
                                <span>Proceed</span>
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div id="tab9" class="tabcontent" style="display: none;">
        <div class="tabcontentinner2">



            <div class="mb-5">

                <div class="">
                    <div class="card-body">
                        <h5 class="mb-3">App Settings</h5>
                        <div style="text-align:left;padding-bottom:2px;">
                            <div class="c-choice1 c-choice--checkbox u-float-left wizard-checkbox pl-2">
                                <input type="checkbox" class="c-choice__input" type="checkbox" name="checkboxes2"
                                    id="enable-xml" [(ngModel)]="settingInput.enableXMLVersionLogging">
                                <label for="enable-xml" class="c-choice__label custom-label">Enable Xml Version
                                    Logging</label>
                            </div>

                        </div>
                    </div>

                </div>
            </div>



        </div>

    </div>

    <div id="tab10" class="tabcontent" style="display: none;">
        <div class="tabcontentinner" *ngIf="isAdminUser">
            <div class="mb-5 col-lg-6 col-md-8 col-sm-12 col-xs-12 mx-auto">
                <div class="card-body">
                    <!-- <h4 class="mb-3 text-center">Web facing SEO Content</h4> -->
                    <div class="order-md-1 mt-5" *ngIf="settingInput.webFacingContent.calculationTypeId > 0">
                        <div class="row">
                            <div class="col-12 p-0">
                                <div class="col-md-12 mb-3 p-0">
                                    <label for="calculationTypeId">Select Calculator or Page</label>
                                    <ng-select [clearable]="false" [items]="calculators" bindLabel="name"
                                        placeholder="Select Calculator or Page" [searchable]="true" bindValue="value"
                                        [(ngModel)]="settingInput.webFacingContent.calculationTypeId"
                                        name="calculationTypeId" #calcId="ngModel" required
                                        [class.is-invalid]="showValidationErrors && calcId.invalid"
                                        (change)="onCalculatorChange()">
                                    </ng-select>
                                    <div class="invalid-feedback d-block"
                                        *ngIf="showValidationErrors && calcId.invalid">
                                        Please select a calculator.
                                    </div>
                                </div>
                                <div class="col-md-12 p-0">
                                    <div class="button-row sticky-wrapper" #stickyWrapper>
                                        <div class="left-buttons">
                                            <button type="button" class="btn me-2" *ngIf="showSEOContent"
                                                [ngClass]="showEditor ? 'btn-primary' : 'btn-secondary'"
                                                (click)="showEditor = true">Editor</button>

                                            <button type="button" class="btn mx-auto" *ngIf="showSEOContent"
                                                [ngClass]="!showEditor ? 'btn-primary' : 'btn-secondary'"
                                                (click)="showEditor = false">Preview</button>
                                        </div>
                                        <div class="right-buttons">
                                            <button value="Accept" class="btn btn-secondary border me-2"
                                                (click)="saveWebFacing(false)"> Save
                                            </button>

                                            <button value="Accept" class="btn btn-secondary border me-2"
                                                [disabled]="disablePublishBtn" (click)="saveWebFacing(true)">
                                                {{!isPublish ? 'Publish' : 'Re-Publish'}}
                                            </button>

                                            <!-- <button type="button" value="Cancel"  [disabled]="isDisabled || !disablePublishBtn"
                                                class="btn btn-secondary border btnSave" (click)="cancelSCO()">
                                                <img class="canceltimg" src="assets/common/images/Transparent.gif"><img>
                                                Cancel
                                            </button> -->
                                            <button type="button" class="btn btn-secondary border d-none"
                                                (click)="onSync()">Sync
                                            </button>

                                        </div>
                                    </div>
                                    <p *ngIf="publishedDate?.trim()" class="published-info"><span>Last Published:
                                        </span> {{ publishedDate}}</p>
                                </div>
                                <div *ngIf="showEditor">
                                    <!-- Meta Title -->
                                    <div class="col-md-12 mb-3 p-0">
                                        <label for="metaTitle">Meta Titles (title, meta-title, og:title)</label>
                                        <input type="text" class="form-control" id="metaTitle"
                                            [(ngModel)]="settingInput.webFacingContent.metaTitle" name="metaTitle"
                                            #metaTitle="ngModel" required maxlength="60"
                                            [class.is-invalid]="showValidationErrors && metaTitle.invalid">
                                        <div class="d-flex justify-content-between align-items-start w-100">
                                            <div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaTitle.invalid">
                                                    Please enter a meta title.
                                                </div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaTitle.errors?.['maxlength']">
                                                    Title cannot exceed 60 characters.
                                                </div>
                                            </div>
                                            <small class="text-muted text-end char-count mt-2 ms-2">
                                                {{ settingInput.webFacingContent.metaTitle?.length || 0 }}/60
                                            </small>
                                        </div>
                                    </div>

                                    <!-- Meta Description -->
                                    <div class="col-md-12 mb-3 p-0">
                                        <label for="metaDescription">Meta Description</label>
                                        <textarea class="form-control" id="metaDescription"
                                            [(ngModel)]="settingInput.webFacingContent.metaDescription"
                                            name="metaDescription" #metaDescription="ngModel" required maxlength="160"
                                            [class.is-invalid]="showValidationErrors && metaDescription.invalid"></textarea>
                                        <div class="d-flex justify-content-between align-items-start w-100">
                                            <div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaDescription.invalid">
                                                    Please enter a meta description.
                                                </div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaDescription.errors?.['maxlength']">
                                                    Meta description cannot exceed 160 characters.
                                                </div>
                                            </div>
                                            <small class="text-muted text-end char-count mt-2 ms-2">
                                                {{ settingInput.webFacingContent.metaDescription?.length || 0 }}/160
                                            </small>
                                        </div>
                                    </div>

                                    <!-- Meta Keywords -->
                                    <div class="col-md-12 mb-3 p-0">
                                        <label for="metaKeywords">Meta Keywords</label>
                                        <textarea type="text" class="form-control" id="metaKeywords"
                                            [(ngModel)]="settingInput.webFacingContent.metaKeywords" name="metaKeywords"
                                            #metaKeywords="ngModel" required maxlength="255"
                                            [class.is-invalid]="showValidationErrors && metaKeywords.invalid"></textarea>
                                        <div class="d-flex justify-content-between align-items-start w-100">
                                            <div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaKeywords.invalid">
                                                    Please enter meta keywords.
                                                </div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && metaKeywords.errors?.['maxlength']">
                                                    Meta keywords cannot exceed 255 characters.
                                                </div>
                                            </div>
                                            <small class="text-muted text-end char-count mt-2 ms-2">
                                                {{ settingInput.webFacingContent.metaKeywords?.length || 0 }}/255
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-12 mb-3 p-0">
                                        <label for="pageHeading">Page Heading (H1)</label>
                                        <input type="text" class="form-control" id="pageHeading"
                                            [(ngModel)]="settingInput.webFacingContent.pageHeading" name="pageHeading"
                                            #pageHeading="ngModel" required maxlength="160"
                                            [class.is-invalid]="showValidationErrors && pageHeading.invalid">
                                        <div class="d-flex justify-content-between align-items-start w-100">
                                            <div>
                                                <div class="invalid-feedback d-block"
                                                    [class.invisible]="!(showValidationErrors && pageHeading.invalid)">
                                                    Please enter a page heading.
                                                </div>
                                                <div class="invalid-feedback d-block"
                                                    [class.invisible]="!(showValidationErrors && pageHeading.errors?.['maxlength'])">
                                                    Page heading cannot exceed 160 characters.
                                                </div>
                                            </div>
                                            <small class="text-muted text-end char-count mt-2">
                                                {{ settingInput.webFacingContent.pageHeading?.length || 0 }}/160
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-12 mb-3 p-0">
                                        <label for="pageDescription">Page Description (H2)</label>
                                        <textarea class="form-control" id="pageDescription"
                                            [(ngModel)]="settingInput.webFacingContent.pageDescription"
                                            name="pageDescription" #pageDescription="ngModel" required maxlength="500"
                                            [class.is-invalid]="showValidationErrors && pageDescription.invalid"></textarea>
                                        <div class="d-flex justify-content-between align-items-start w-100">
                                            <div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && pageDescription.invalid">
                                                    Please enter a page description.
                                                </div>
                                                <div class="invalid-feedback d-block"
                                                    *ngIf="showValidationErrors && pageDescription.errors?.['maxlength']">
                                                    Page description cannot exceed 500 characters.
                                                </div>
                                            </div>
                                            <small class="text-muted text-end char-count mt-2 ms-2">
                                                {{ settingInput.webFacingContent.pageDescription?.length || 0 }}/500
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-12 mb-3 p-0" *ngIf="showSEOContent">
                                        <label for="SeoContent">SEO Content</label>
                                        <app-editor [(ngModel)]="settingInput.webFacingContent.seoContent"
                                            name="seoContent" [config]="editorConfig" #seoContent="ngModel"
                                            (ngModelChange)="onSeoContentChange($event)"
                                            (blur)="onSeoContentBlur($event)" (ready)="onReady($event)"
                                            [required]="true"
                                            [class.is-invalid]="showValidationErrors && seoContent.invalid">
                                        </app-editor>
                                        <!-- <ckeditor [editor]="Editor" [config]="editorConfig" (ready)="onReady($event)"
                                            [(ngModel)]="settingInput.webFacingContent.seoContent" name="seoContent"
                                            #seoContent="ngModel" (ngModelChange)="onSeoContentChange($event)"
                                            (blur)="onSeoContentBlur($event)" required
                                            [class.is-invalid]="showValidationErrors && seoContent.invalid">
                                        </ckeditor> -->
                                        <div class="invalid-feedback d-block"
                                            *ngIf="showValidationErrors && seoContent.invalid">
                                            Please enter SEO content.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 my-3" style="background-color: #ffff;" *ngIf="!showEditor">
                                <div class="calculator-desc p-0 pt-3" *ngIf="!showEditor && previewSeoContent?.trim()">
                                    <div class="calculator-footer-header">
                                        <div class="calculator-fix-width" id="seo-content">
                                            <div [innerHTML]="previewSeoContent | sanitizeHtml"
                                                class="seo-content-rendered"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footerbutton" *ngIf="!hideSubmit">
        <button value="Accept" class="btn btn-secondary border btnSave" (click)="save()">
            <img class="rightimg" src="assets/common/images/Transparent.gif" height=""> Accept
        </button>


        <button type="button" value="Cancel" class="btn btn-secondary border btnSave" (click)="cancelRedirect()">
            <img class="canceltimg" src="assets/common/images/Transparent.gif" height="">
            Cancel
        </button>
    </div>

    <div id="reportDlgVR" class="modal fade" role="dialog" style="display:none;overflow:auto;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>Protective Device Selector</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="job-number" class="c-field__label">Manufacturer</label>
                                    <div class="custom-selectbox drpCableSizing-select">
                                        <select id="ddlManufacturer" class="c-select drpCableSizing-select">
                                            <option style="font-size: 16px" [selected]="item.id == defaultManId"
                                                *ngFor="let item of manufacturerOutput let ind=index;"
                                                value="{{item.id}}">
                                                {{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="job-number" class="c-field__label"></label>
                                    <div id="divlogo" style="height: 40px; width:210px;">
                                        <img alt="Manufacturer" title="Manufacturer Image"
                                            style='width:100%;max-height: 100%;border-radius: 15px;margin-top: 22px'
                                            src="assets/cablepro/logo/a.png">
                                    </div>
                                </div>


                                <!-- <svg id="divlogo" width="200" height="200">       
                                <image src="" height="200" width="200"/>
                              </svg> -->

                            </div>
                        </div>

                    </div>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="job-number" class="c-field__label">Family</label>
                            <div class="custom-selectbox drpCableSizing-select">
                                <select id="ddlFamily" class="c-select drpCableSizing-select">
                                    <option style="font-size: 16px" [selected]="item.familyid == defaultFamilyId"
                                        *ngFor="let item of familyOutput let ind=index;" value="{{item.familyid}}">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="job-number" class="c-field__label">Model</label>
                            <div class="custom-selectbox drpCableSizing-select">
                                <select id="ddlModel" class="c-select">
                                    <option style="font-size: 16px" [selected]="item.id == defaultModelId"
                                        *ngFor="let item of modelOutput let ind=index;" value="{{item.id}}">
                                        {{item.name}}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>
                    <div class="form-horizontal">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="job-number" class="c-field__label">Rating (A)</label>
                                    <div class="custom-selectbox drpCableSizing-select">
                                        <select id="ddlrating" class="c-select">
                                            <option style="font-size: 16px" [selected]="item.ina == defaultRatingId"
                                                *ngFor="let item of mcbOutput let ind=index;" value="{{item.ina}}">
                                                {{item.ina}}
                                            </option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-horizontal">
                        <div class="row">
                            <div class="col-12">
                                <!-- <div class="c-field panel c-field u-mb-small u-float-left">
                                <label for="job-number" class="c-field__label">{{selectListFive}}</label>
                                <div class="custom-selectbox drpCableSizing-select">
                                <select id="ddlcurve" class="c-select"  >
                                    <option style="font-size: 16px" [selected]="ind == 0"  *ngFor="let item of curveOutput let ind=index;"  value="{{item.cc}}">
                                        {{item.cc}}
                                    </option>
                                </select>
                            </div>
                            </div> -->

                                <div class="form-group">
                                    <label for="job-number" class="c-field__label">{{selectListFive}}</label>
                                    <div class="custom-selectbox drpCableSizing-select">
                                        <select id="ddlcurve" class="c-select">
                                            <option style="font-size: 16px" [selected]="item.cc == defaultCurveId"
                                                *ngFor="let item of curveOutput let ind=index;" value="{{item.cc}}">
                                                {{item.cc}}
                                            </option>
                                        </select>
                                    </div>

                                </div>


                            </div>

                        </div>
                    </div>
                    <div class="form-horizontal">
                        <div class="row">

                            <div class="col-12">
                                <div class="c-field panel">
                                    <label for="job-number" style="color: #343A40;" class="c-field__label">Show breaking
                                        capacities
                                    </label>
                                    <input class="choice__input" type="checkbox" id="chkexportlimited"
                                        (change)="ExportLimitedChange($event)" />
                                </div>


                                <div *ngIf="showFilter" class="c-field u-mb-small">

                                    <!-- <input style="width:100px;padding-right: 15px" class="number-input" type="number" name="val1" (change)="FilterChange($event)" [(ngModel)]="FilterBreaking" min="1" max="1000" (change)="CommonValidationFn(3, $event,2)" > -->
                                    <!-- <span class="Vspan1">V </span> -->
                                    <!--<label class="filelable">Also used for Max Demand calculations</label>-->



                                    <div class="col-12">
                                        <div class="row Poles">
                                            <div class="table-scrollable table-scrollable-borderless" style="overflow: auto;
                            height: 210px;">
                                                <table class="table table-hover table-light">
                                                    <thead style="background-color: #e6e6e6 !important;">
                                                        <tr class="uppercase">
                                                            <th>
                                                                Poles
                                                            </th>
                                                            <!-- <th>
                                                ue_min_v
                                            </th> -->
                                                            <th>
                                                                Voltage (V)
                                                            </th>
                                                            <th>
                                                                Breaking capacity (kA)
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tr *ngFor="let m of breakingOutput; let index = index">

                                                        <td>
                                                            {{m.poles}}
                                                        </td>
                                                        <!-- <td>
                                            {{m.uminv}}
                                        </td> -->
                                                        <td>
                                                            {{m.umaxv}}
                                                        </td>
                                                        <td>
                                                            <span>{{m.icuka}}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div  class="row">
                    <div class="col-12" *ngIf="showFilter" >
                        <label for="job-number"  style="color:red;"  class="c-field__label"> The breaking capacity of some devices are not available and these will not be excluded by the filter.
                        </label>
                        </div></div> -->

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="CloseReport()">Cancel</button>
                    <button type="button" class="btn btn-primary" id="btnaccept"
                        (click)="AcceptReport('1')">Accept</button>
                </div>
            </div>
        </div>
    </div>
    <div id="CurveDataDialog" class="modal fade" role="dialog" style="display:none;overflow:auto;width:90%;left:5%;">
        <div class="modal-dialog" role="document" style="width:100%;max-width: 1245px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>Protective Device Configuration (<span id="mcbacb-device"></span>)</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>


                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="CloseCurveData()">Cancel</button>

                    <button type="button" class="btn btn-danger" (click)="AcceptReport()">Reset</button>
                    <button type="button" class="btn btn-primary" (click)="savexml()">Accept</button>



                </div>
            </div>
        </div>
    </div>
    <div id="custom-restriction-model" class="modal fade" tabindex="-1" role="dialog" style="display:none">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h5>Custom Report Fields</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="popup-body-font"><span>Number of Report Fields limit is 3</span></p>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="ListSubscriptionExpiredModel2" class="modal fade" tabindex="-1" role="dialog" style="display:none">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div *ngIf="hasPlanExpired" class="modal-header">
                <h5>{{expiredPlanHeadingText}}</h5>
            </div>
            <div *ngIf="!hasPlanExpired" class="modal-header">
                <h5>{{expiredPlanHeadingText}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="popup-body-font"><label>{{expiredPlanBodyText}}</label></p>
            </div>

            <div *ngIf="hasPlanExpired" class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="extendTrialPeriod()"
                    *ngIf="planExtendedCount < 2" [disabled]="isLoaderForExtendPlan">
                    Extend Free Trial <i *ngIf="isLoaderForExtendPlan" class="fa fa-spinner fa-spin"></i>
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="GoToPricing()">
                    Go to
                    Pricing
                </button>
            </div>
            <div *ngIf="!hasPlanExpired" class="modal-footer">

                <button type="button" class="btn btn-primary btn-gotopricing" data-dismiss="modal"
                    (click)="GoToPricing()">
                    Go to
                    Pricing
                </button>
                <button type="button" style="display:none;" class="btn btn-primary btn-upgrade" data-dismiss="modal"
                    (click)="SetUpgradeLink()">Upgrade</button>
                <button type="button" class="btn btn-secondary expiry" data-dismiss="modal">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>
</div>
<style>
    .Poles table tbody tr:nth-child(even) {
        background-color: #f4f3fb !important;
    }

    :host ::ng-deep .seo-content-rendered .media {
        display: block !important;
    }

    :host ::ng-deep .seo-content-rendered img {
        max-width: 100%;
        height: 100%;
    }

    :host ::ng-deep .seo-content-rendered ul,
    :host ::ng-deep .seo-content-rendered ol {
        list-style-type: revert !important;
    }

    :host ::ng-deep .p-editor .p-editor-toolbar {
        display: none !important;
    }

    :host ::ng-deep .seo-content-rendered .video-container {
        position: relative;
        width: 100%;
        max-width: 100%;
        padding-bottom: 56.25%;
        margin: 16px 0;
    }

    :host ::ng-deep .seo-content-rendered .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    :host ::ng-deep .seo-content-rendered table {
        width: 100%;
        min-width: 600px;
        border-collapse: collapse;
        font-family: Arial, sans-serif;
    }

    :host ::ng-deep .seo-content-rendered th,
    :host ::ng-deep .seo-content-rendered td {
        padding: 12px;
        border: 1px solid #ccc;
        vertical-align: top;
        white-space: normal;
    }

    :host ::ng-deep .seo-content-rendered th {
        background-color: #f4f4f4;
        text-align: left;
    }

    :host ::ng-deep li {
        margin-left: 16px;
    }

    :host ::ng-deep .seo-content-rendered .image {
        max-width: 100%;
        display: flex;
        justify-content: center;
    }

    :host ::ng-deep .seo-content-rendered .table {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    :host ::ng-deep .calculator-desc {
        padding: 0 1rem;
        font-family: "Open Sans", sans-serif !important;
    }

    :host ::ng-deep .calculator-desc ul {
        padding: 10px 15px;
    }

    :host ::ng-deep .calculator-desc li {
        margin: 10px 0;
        padding-left: 10px;
        list-style-type: disc;
    }

    :host ::ng-deep .calculator-footer-header {
        /* display: flex; */
        justify-content: center;
        align-items: center;
    }

    :host ::ng-deep .calculator-fix-width {
        max-width: 800px;
    }

    /* :host ::ng-deep .calculator-fix-width h3 {
        margin-bottom: 27px;
    } */

    :host ::ng-deep .video-container {
        position: relative;
        width: 100%;
        max-width: 100%;
        padding-bottom: 56.25%;
        margin: 16px 0;
    }

    :host ::ng-deep .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    :host ::ng-deep .calc-sub-header {
        margin-top: 16px;
        margin-bottom: 10px !important;
        font-size: 1.5rem;
    }

    :host ::ng-deep .calculator-fix-width .media {
        display: block !important;
    }

    :host ::ng-deep .calculator-fix-width img {
        max-width: 100%;
        height: 100%;
    }

    :host ::ng-deep .calculator-fix-width ul,
    :host ::ng-deep .calculator-fix-width ol {
        list-style-type: revert !important;
    }

    :host ::ng-deep .p-editor .p-editor-toolbar {
        display: none !important;
    }

    :host ::ng-deep .calculator-fix-width .video-container {
        position: relative;
        width: 100%;
        max-width: 100%;
        padding-bottom: 56.25%;
        margin: 16px 0;
    }

    :host ::ng-deep .calculator-fix-width .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    :host ::ng-deep .calculator-fix-width table {
        width: 100%;
        min-width: 600px;
        border-collapse: collapse;
        font-family: Arial, sans-serif;
    }

    :host ::ng-deep .calculator-fix-width th,
    :host ::ng-deep .calculator-fix-width td {
        padding: 12px;
        border: 1px solid #ccc !important;
        vertical-align: top;
        white-space: normal;
    }

    :host ::ng-deep .table td {
        border-top: 1px solid #cccccc;
    }

    :host ::ng-deep .calculator-fix-width th {
        background-color: #ededed;
        text-align: left;
        border-bottom: 1px solid #ccc !important;
    }

    :host ::ng-deep li {
        margin-left: 16px;
    }

    :host ::ng-deep .calculator-fix-width figure.image {
        max-width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    :host ::ng-deep .calculator-fix-width figure.image figcaption {
        text-align: center;
        margin-top: 8px;
        color: #354052;
        font-weight: 600;
        font-size: 14px;
    }

    :host ::ng-deep .calculator-fix-width .table {
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    :host ::ng-deep .calculator-fix-width img {
        max-width: 100%;
        height: 100%;
    }

    :host ::ng-deep footer {
        background-color: #E9EAEE;
        color: #000;
        padding: 10px 20px;
        text-align: center;
        font-size: 14px;
    }

    :host ::ng-deep .footer-content {
        display: inline-flex;
        gap: 5px;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
    }

    :host ::ng-deep .fotter-content a {
        text-decoration: none;
        margin: 0 5px;
        color: blue;
    }

    :host ::ng-deep .button-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .left-buttons,
    :host ::ng-deep .right-buttons {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    :host ::ng-deep .right-buttons .rightimg {
        width: 21px;
        height: 20px;
        margin-right: 3px;
    }

    :host ::ng-deep .published-info {
        text-align: end;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px;
    }

    :host ::ng-deep .char-count {
        display: flex !important;
        justify-content: flex-end;
    }

    :host ::ng-deep .calculator-fix-width p {
        font-family: "Open Sans", sans-serif !important;
        font-size: 12px;
    }

    :host ::ng-deep .calculator-fix-width h3 {
        margin-top: 16px !important;
        margin-bottom: 10px !important;
        font-size: 1.5rem !important;
    }

    :host ::ng-deep .calculator-footer-header p {
        font-size: 14px;
    }
</style>
<script type="text/javascript">
    //     var ctx = document.getElementById('myChart').getContext('2d');
    // var chart = new Chart(ctx, {
    //     // The type of chart we want to create
    //     type: 'line',

    //     // The data for our dataset
    //     data: {
    //         labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //         datasets: [{
    //             label: 'My First dataset',
    //             backgroundColor: 'rgb(255, 99, 132)',
    //             borderColor: 'rgb(255, 99, 132)',
    //             data: [0, 10, 5, 2, 20, 30, 45]
    //         }]
    //     },

    //     // Configuration options go here
    //     options: {}
    // });
    /// javascript code
    window.onload = function () {

        var chart = new CanvasJS.Chart("chartContainer", {
            animationEnabled: true,
            zoomEnabled: true,
            theme: "dark2",
            title: {
                text: "Growth in Internet Users Globally"
            },
            axisX: {
                title: "Year",
                valueFormatString: "####",
                interval: 2
            },
            axisY: {
                logarithmic: true, //change it to false
                title: "Internet Users (Log)",
                titleFontColor: "#6D78AD",
                lineColor: "#6D78AD",
                gridThickness: 0,
                lineThickness: 1,
                labelFormatter: addSymbols
            },
            axisY2: {
                title: "Internet Users",
                titleFontColor: "#51CDA0",
                logarithmic: false, //change it to true
                lineColor: "#51CDA0",
                gridThickness: 0,
                lineThickness: 1,
                labelFormatter: addSymbols
            },
            legend: {
                verticalAlign: "top",
                fontSize: 16,
                dockInsidePlotArea: true
            },
            data: [{
                type: "line",
                xValueFormatString: "####",
                showInLegend: true,
                name: "Log Scale",
                dataPoints: [
                    { x: 1994, y: 25437639 },
                    { x: 1995, y: 44866595 },
                    { x: 1996, y: 77583866 },
                    { x: 1997, y: 120992212 },
                    { x: 1998, y: 188507628 },
                    { x: 1999, y: 281537652 },
                    { x: 2000, y: 414794957 },
                    { x: 2001, y: 502292245 },
                    { x: 2002, y: 665065014 },
                    { x: 2003, y: 781435983 },
                    { x: 2004, y: 913327771 },
                    { x: 2005, y: 1030101289 },
                    { x: 2006, y: 1162916818 },
                    { x: 2007, y: 1373226988 },
                    { x: 2008, y: 1575067520 },
                    { x: 2009, y: 1766403814 },
                    { x: 2010, y: 2023202974 },
                    { x: 2011, y: 2231957359 },
                    { x: 2012, y: 2494736248 },
                    { x: 2013, y: 2728428107 },
                    { x: 2014, y: 2956385569 },
                    { x: 2015, y: 3185996155 },
                    { x: 2016, y: 3424971237 }
                ]
            },
            {
                type: "line",
                xValueFormatString: "####",
                axisYType: "secondary",
                showInLegend: true,
                name: "Linear Scale",
                dataPoints: [
                    { x: 1994, y: 25437639 },
                    { x: 1995, y: 44866595 },
                    { x: 1996, y: 77583866 },
                    { x: 1997, y: 120992212 },
                    { x: 1998, y: 188507628 },
                    { x: 1999, y: 281537652 },
                    { x: 2000, y: 414794957 },
                    { x: 2001, y: 502292245 },
                    { x: 2002, y: 665065014 },
                    { x: 2003, y: 781435983 },
                    { x: 2004, y: 913327771 },
                    { x: 2005, y: 1030101289 },
                    { x: 2006, y: 1162916818 },
                    { x: 2007, y: 1373226988 },
                    { x: 2008, y: 1575067520 },
                    { x: 2009, y: 1766403814 },
                    { x: 2010, y: 2023202974 },
                    { x: 2011, y: 2231957359 },
                    { x: 2012, y: 2494736248 },
                    { x: 2013, y: 2728428107 },
                    { x: 2014, y: 2956385569 },
                    { x: 2015, y: 3185996155 },
                    { x: 2016, y: 3424971237 }
                ]
            }]
        });
        chart.render();

        function addSymbols(e) {
            var suffixes = ["", "K", "M", "B"];

            var order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);
            if (order > suffixes.length - 1)
                order = suffixes.length - 1;

            var suffix = suffixes[order];
            return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
        }

    }

</script>